<template>
  <div id="appNews">
    <!--新闻详情-->
    <div class="appContent">
      <article class="appDetails">
        <h3>{{title}}</h3>
        <h4><span>来源：{{author}}</span><span>发布时间：{{createTime}}</span></h4>
        <p class="wordSet" v-html="content"></p>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: null,
      author: null,
      createTime: null,
      content: null
    }
  },
  created () {
    this.ListenerMobile()
  },
  methods: {
    ListenerMobile () {
      const _self = this
      window.document.addEventListener('message', function (e) { // 接收数据
        if (e.data && e.data != null && e.data !== '') {
          let data = JSON.parse(e.data)
          _self.title = data.title
          _self.author = data.author
          _self.createTime = data.createTime
          _self.content = data.content
        }
      })
    }
  }
}
</script>

<style>
  .appContent{
    width: 100%;
    padding: 30px 20px;
  }
  .appDetails{
    width: 100%;
    color: #333;
  }
  .appDetails h3{
    font-size: 16px;
    margin: 10px 0px;
    font-weight: normal;
  }
  .appDetails h4{
    margin: 5px 0px;
  }
  .appDetails h4 span{
    font-size: 12px;
    color: #aaa;
    margin: 0px 8px;
  }
  .appDetails p{
    width: 100%;
    text-align: left;
    text-indent: 2em;
  }
  .wordSet img{
    max-width: 90%;
    text-align: center;
  }
  .wordSet p{
    line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/app/AppNewsDetails.vue